import React from "react";

import { Row, Col } from "antd";
// import { ViewComponent } from "@reco-w/core-ui";
import { template, formatDate } from "@reco-m/core";

import { Namespaces } from "@reco-w/policy-layout-models";
import { headerModel } from "@reco-w/fxkw-layout-models";
import { PageHeader as oldPageHeader } from "@reco-w/policy-layout-blocks";

export namespace PageHeader {
    export interface IProps<S extends IState = IState> extends oldPageHeader.IProps<S> { }

    export interface IState extends oldPageHeader.IState, headerModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends oldPageHeader.Component<P, S> {
        render(): React.ReactNode {
            const arr = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
            const myDate = new Date();
            const cycle = arr[myDate.getDay()];
            const time = formatDate(myDate, "yyyy-MM-dd");
            return (
                <div className="policydeal-header">
                    <div className="container">
                        <Row align="middle">
                            <Col span={16}>
                                <div className="title">
                                    <img src="assets/images/con_logo.png" />
                                </div>
                            </Col>
                            <Col span={8}>
                                <span className="data">
                                    {time} {cycle}
                                </span>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.header]);
}
